import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './layouts/AppLayout';
import { PublicInfoLayout } from './layouts/PublicInfoLayout';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { AccountDeletePage } from './pages/AccountDeletePage';
import { InfoPage } from './pages/InfoPage';
import { SettingsPage } from './pages/SettingsPage';
import { ApiariesPage } from './pages/ApiariesPage';
import { ApiaryDetailPage } from './pages/ApiaryDetailPage';
import { HivesPage } from './pages/HivesPage';
import { HiveDetailPage } from './pages/HiveDetailPage';
import { QueensPage } from './pages/QueensPage';
import { DriftplanPage } from './pages/DriftplanPage';
import { ReportsPage } from './pages/ReportsPage';
import { ProductsPage } from './pages/ProductsPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CustomersPage } from './pages/CustomersPage';
import { OrdersPage } from './pages/OrdersPage';
import { OrderDetailPage } from './pages/OrderDetailPage';
import { ShipmentFoljesedelPage } from './pages/ShipmentFoljesedelPage';
import { SuppliersPage } from './pages/SuppliersPage';
import { ReceivingPage } from './pages/ReceivingPage';
import { ReceivingDetailPage } from './pages/ReceivingDetailPage';
import { ReceivingRebuildPage } from './pages/ReceivingRebuildPage';
import { PurchaseDetailPage } from './pages/PurchaseDetailPage';
import { LedgerPage } from './pages/LedgerPage';
import { SitesPage } from './pages/SitesPage';
import { ContainerInfoPage } from './pages/ContainerInfoPage';
import { TraceabilityPage } from './pages/TraceabilityPage';
import { SettingsPlanPage } from './pages/settings/SettingsPlanPage';
import { CompanySettingsPage } from './pages/settings/CompanySettingsPage';
import { SuperAdminPage } from './pages/SuperAdminPage';
import { ModulePlaceholderPage } from './pages/ModulePlaceholderPage';
import { ProductionPage } from './pages/ProductionPage';
import { OfficePage } from './pages/OfficePage';
import { OfficeContractcalcPage } from './pages/OfficeContractcalcPage';
import { OfficeSensorTrafficPage } from './pages/OfficeSensorTrafficPage';
import { FortnoxOverviewPage } from './pages/FortnoxOverviewPage';
import { QualityPage } from './pages/QualityPage';
import { QualityDocsPage } from './pages/QualityDocsPage';
import { QualityDocDetailPage } from './pages/QualityDocDetailPage';
import { QualityDocsPrintPage } from './pages/QualityDocsPrintPage';
import { QualityHazardsPage } from './pages/QualityHazardsPage';
import { QualityHazardsPrintPage } from './pages/QualityHazardsPrintPage';
import { QualitySelfchecksPage } from './pages/QualitySelfchecksPage';
import { QualityVisitorsPage } from './pages/QualityVisitorsPage';
import { ExtractionsPage } from './pages/ExtractionsPage';
import { BottlingPage } from './pages/BottlingPage';
import { BlendingPage } from './pages/BlendingPage';
import { FlavorPage } from './pages/FlavorPage';
import { PollenPage } from './pages/PollenPage';
import { HoneyroomPage } from './pages/HoneyroomPage';
import { GuestOnly, RequireAuth, RequireRead, RequireSuperAdmin } from './lib/rbac';

export default function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={(
          <GuestOnly>
            <LoginPage />
          </GuestOnly>
        )}
      />
      <Route
        path="/signup"
        element={(
          <GuestOnly>
            <SignupPage />
          </GuestOnly>
        )}
      />
      <Route
        path="/verify-email"
        element={(
          <GuestOnly>
            <VerifyEmailPage />
          </GuestOnly>
        )}
      />
      <Route
        path="/forgot-password"
        element={(
          <GuestOnly>
            <ForgotPasswordPage />
          </GuestOnly>
        )}
      />
      <Route
        path="/reset-password/:token"
        element={(
          <GuestOnly>
            <ResetPasswordPage />
          </GuestOnly>
        )}
      />
      <Route path="/info" element={<PublicInfoLayout />}>
        <Route index element={<InfoPage />} />
        <Route path=":containerId" element={<ContainerInfoPage />} />
      </Route>
      <Route
        path="/print/orders/:orderId/foljesedel/:shipmentId"
        element={(
          <RequireRead moduleCode="orders">
            <ShipmentFoljesedelPage printMode />
          </RequireRead>
        )}
      />
      <Route
        path="/"
        element={(
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        )}
      >
        <Route index element={<HomePage />} />
        <Route path="dashboard" element={<HomePage />} />
        <Route
          path="superadmin"
          element={(
            <RequireSuperAdmin>
              <SuperAdminPage />
            </RequireSuperAdmin>
          )}
        />
        <Route
          path="settings"
          element={(
            <RequireRead moduleCode="settings">
              <SettingsPage />
            </RequireRead>
          )}
        />
        <Route
          path="settings/plan"
          element={(
            <RequireRead moduleCode="settings">
              <SettingsPlanPage />
            </RequireRead>
          )}
        />
        <Route
          path="settings/company"
          element={(
            <RequireRead moduleCode="settings">
              <CompanySettingsPage />
            </RequireRead>
          )}
        />
        <Route
          path="apiaries"
          element={(
            <RequireRead moduleCode="apiaries">
              <ApiariesPage />
            </RequireRead>
          )}
        />
        <Route
          path="apiaries/:id"
          element={(
            <RequireRead moduleCode="apiaries">
              <ApiaryDetailPage />
            </RequireRead>
          )}
        />
        <Route
          path="hives"
          element={(
            <RequireRead moduleCode="hives">
              <HivesPage />
            </RequireRead>
          )}
        />
        <Route
          path="hives/:id"
          element={(
            <RequireRead moduleCode="hives">
              <HiveDetailPage />
            </RequireRead>
          )}
        />
        <Route
          path="queens"
          element={(
            <RequireRead moduleCode="queens">
              <QueensPage />
            </RequireRead>
          )}
        />
        <Route
          path="production"
          element={(
            <RequireRead moduleCode="extractions">
              <ProductionPage />
            </RequireRead>
          )}
        />
        <Route
          path="extractions"
          element={(
            <RequireRead moduleCode="extractions">
              <ExtractionsPage />
            </RequireRead>
          )}
        />
        <Route
          path="blending"
          element={(
            <RequireRead moduleCode="bottling">
              <BlendingPage />
            </RequireRead>
          )}
        />
        <Route
          path="flavor"
          element={(
            <RequireRead moduleCode="bottling">
              <FlavorPage />
            </RequireRead>
          )}
        />
        <Route
          path="pollen"
          element={(
            <RequireRead moduleCode="bottling">
              <PollenPage />
            </RequireRead>
          )}
        />
        <Route
          path="honeyroom"
          element={(
            <RequireRead moduleCode="bottling">
              <HoneyroomPage />
            </RequireRead>
          )}
        />
        <Route
          path="driftplan"
          element={(
            <RequireRead moduleCode="driftplan">
              <DriftplanPage />
            </RequireRead>
          )}
        />
        <Route
          path="driftplan/:year"
          element={(
            <RequireRead moduleCode="driftplan">
              <DriftplanPage />
            </RequireRead>
          )}
        />
        <Route
          path="reports"
          element={(
            <RequireRead moduleCode="reports">
              <ReportsPage />
            </RequireRead>
          )}
        />
        <Route
          path="bottling"
          element={(
            <RequireRead moduleCode="bottling">
              <BottlingPage />
            </RequireRead>
          )}
        />
        <Route
          path="products"
          element={(
            <RequireRead moduleCode="products">
              <ProductsPage />
            </RequireRead>
          )}
        />
        <Route
          path="products/:id"
          element={(
            <RequireRead moduleCode="products">
              <ProductDetailPage />
            </RequireRead>
          )}
        />
        <Route
          path="customers"
          element={(
            <RequireRead moduleCode="customers">
              <CustomersPage />
            </RequireRead>
          )}
        />
        <Route
          path="orders"
          element={(
            <RequireRead moduleCode="orders">
              <OrdersPage />
            </RequireRead>
          )}
        />
        <Route
          path="orders/:id"
          element={(
            <RequireRead moduleCode="orders">
              <OrderDetailPage />
            </RequireRead>
          )}
        />
        <Route
          path="suppliers"
          element={(
            <RequireRead moduleCode="suppliers">
              <SuppliersPage />
            </RequireRead>
          )}
        />
        <Route
          path="purchases"
          element={(
            <RequireRead moduleCode="receiving">
              <ReceivingRebuildPage />
            </RequireRead>
          )}
        />
        <Route
          path="purchases/:id"
          element={(
            <RequireRead moduleCode="receiving">
              <PurchaseDetailPage />
            </RequireRead>
          )}
        />
        <Route path="receiving-rebuild" element={<Navigate to="/purchases" replace />} />
        <Route
          path="receiving"
          element={(
            <RequireRead moduleCode="receiving">
              <ReceivingPage />
            </RequireRead>
          )}
        />
        <Route
          path="receiving/:id"
          element={(
            <RequireRead moduleCode="receiving">
              <ReceivingDetailPage />
            </RequireRead>
          )}
        />
        <Route
          path="office"
          element={(
            <RequireRead moduleCode="office">
              <OfficePage />
            </RequireRead>
          )}
        />
        <Route
          path="office/contractcalc"
          element={(
            <RequireRead moduleCode="office">
              <OfficeContractcalcPage />
            </RequireRead>
          )}
        />
        <Route
          path="office/sensor-traffic"
          element={(
            <RequireRead moduleCode="office">
              <OfficeSensorTrafficPage />
            </RequireRead>
          )}
        />
        <Route
          path="office/fortnox"
          element={(
            <RequireRead moduleCode="office">
              <FortnoxOverviewPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality"
          element={(
            <RequireRead moduleCode="quality">
              <QualityPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality/docs"
          element={(
            <RequireRead moduleCode="quality">
              <QualityDocsPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality/docs/print"
          element={(
            <RequireRead moduleCode="quality">
              <QualityDocsPrintPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality/docs/:id"
          element={(
            <RequireRead moduleCode="quality">
              <QualityDocDetailPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality/hazards"
          element={(
            <RequireRead moduleCode="quality">
              <QualityHazardsPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality/hazards/print"
          element={(
            <RequireRead moduleCode="quality">
              <QualityHazardsPrintPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality/selfchecks"
          element={(
            <RequireRead moduleCode="quality">
              <QualitySelfchecksPage />
            </RequireRead>
          )}
        />
        <Route
          path="quality/visitors"
          element={(
            <RequireRead moduleCode="quality">
              <QualityVisitorsPage />
            </RequireRead>
          )}
        />
        <Route
          path="ledger"
          element={(
            <RequireRead moduleCode="ledger">
              <LedgerPage />
            </RequireRead>
          )}
        />
        <Route
          path="sites"
          element={(
            <RequireRead moduleCode="ledger">
              <SitesPage />
            </RequireRead>
          )}
        />
        <Route
          path="traceability"
          element={(
            <RequireRead moduleCode="traceability">
              <TraceabilityPage />
            </RequireRead>
          )}
        />
        <Route
          path="statistics"
          element={(
            <RequireRead moduleCode="statistics">
              <ModulePlaceholderPage title="Statistik" />
            </RequireRead>
          )}
        />
        <Route path="account-delete" element={<AccountDeletePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
